import React, { ReactNode } from "react";
import { Product } from "../../../types";
import DropDownSelector from "../../DropdownSelector";

interface AuctionBaseCardProps {
  children?: any;
  productName: string;
  variants?: Product[];
  variantIndex?: number;
  onVariantSelection?: (variantIndex: number) => void;
}

export const AuctionBaseCard: React.FC<AuctionBaseCardProps> = ({
  children,
  productName,
  variants,
  variantIndex,
  onVariantSelection,
}) => {
  return (
    <div className="border border-auctionStroke shadow-standard rounded-[25px] h-full w-full flex flex-col justify-between">
      <div className="max-w-[295px] mx-auto w-full">
        <div className="flex  flex-col w-full items-center">
          <p className="text-center text-[34px] font-bold mt-[59px]">
            {productName}
          </p>
          {!!variants && (
            <DropDownSelector
              options={variants}
              optionIndex={variantIndex}
              onOptionChange={onVariantSelection}
              containerClassName="mt-[48px]"
            />
          )}
          {children}
        </div>
      </div>
    </div>
  );
};
